const initialState = {
  status: "invalid",
  filters: {
    open: true,
    query: {},
  },
};

export default (state = initialState, action) => {
  switch (action.type) {
    case "CLIENTS_TOGGLE_FILTERS":
      return {
        ...state,
        filters: { ...state.filters, open: !state.filters.open },
      };
    case "CLIENTS_SET_FILTERS_QUERY":
      return {
        ...state,
        filters: { ...state.filters, query: action.query },
      };
    case "CLIENTS_SEARCHING":
      return {
        ...state,
        status: "searching",
      };
    case "CLIENTS_LOADING":
      return {
        ...state,
        status: "loading",
      };
    case "CLIENTS_SUCCESS":
      return {
        ...state,
        status: "success",
        ...action,
      };
    case "CLIENTS_FAILURE":
      return {
        ...state,
        status: "failure",
      };
    default:
      return state;
  }
};
